module.exports = __webpack_public_path__ + "img/icantech.2fe3bdbc.png";